import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Css/View.css";

const ExamEdit = () => {
  const navigate = useNavigate();

  return (
    <div className="student-page">
      {/* Header */}
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          परीक्षा व्यवस्थापन   &gt;&gt; <span>परीक्षा संपादन करा </span>
        </h3>

        <div className="edit-btnn">
    
          <button className="btn outlinee" onClick={() => navigate(-1)}>
            रद्द करा
          </button>
          <button
            className="btn primaryy"
            onClick={() => navigate("/dashboard/exammanagment")}
          >
            सेव्ह करा
          </button>
        </div>
      </div>

      <h2>परीक्षा संपादन करा </h2>

      <div className="info-gridd">
        <div className="info-boxx">
          <label>परीक्षेचे नाव</label>
           <select defaultValue="पूर्व उ. प्रा. शिष्यवृत्ती परीक्षा">
            <option>ज. नवोदय विद्यालय प्रवेश परीक्षा</option>
            <option>पूर्व उ. प्रा. शिष्यवृत्ती परीक्षा</option>
            <option>NMMS Exam</option>
          </select>
        </div>
         <div className="info-boxx">
          <label>परीक्षा प्रकार </label>
           <select defaultValue="परीक्षा प्रकार १">
            <option>परीक्षा प्रकार १</option>
            <option>परीक्षा प्रकार २	</option>
            <option>परीक्षा प्रकार 3	</option>
          </select>
        </div>

        <div className="info-boxx">
          <label>इयत्ता</label>
          <select defaultValue="५ वी">
            <option>५ वी</option>
            <option>६ वी</option>
          </select>
        </div>
         <div className="info-boxx">
          <label>विषय नियुक्त करा	   </label>
          <select defaultValue="मराठी">
            <option>मराठी</option>
            <option>इंग्रजी </option>
            <option>गणित </option>
          </select>
        </div> 
        <div className="info-boxx">
          <label>परीक्षेची तारीख</label>
          <input type="date" defaultValue="५ जानेवारी, २०२६" />
        </div>
        <div className="info-boxx">
          <label>परीक्षेचा कालावधी </label>
          <input type="time" defaultValue="१ तास " />
        </div>
        <div className="info-boxx">
          <label>परीक्षेची सुरूवातीची वेळ</label>
          <input type="time" defaultValue="सकाळी १०:००" />
        </div>
        <div className="info-boxx">
          <label>परीक्षेची समाप्तीची वेळ</label>
          <input type="time" defaultValue="सकाळी ११:००" />
        </div>

        <div className="info-boxx">
          <label>गुण</label>
          <input defaultValue="२५ गुण" />
        </div>
         <div className="info-boxx">
          <label>उत्तर निवड प्रकार </label>
          <select defaultValue="ABCD">
            <option>ABCD</option>
           </select>
        </div> 
         <div className="info-boxx">
          <label>नियुक्त शिक्षक </label>
          <input defaultValue="सुनीता देशमुख" />
        </div>
        <div className="info-boxx">
  <label>सूचना</label>
  <ul className="info-list">
    <li>परीक्षा एकूण १०० गुणांची असेल.</li>
    <li>एकूण ४ विषय असतील – मराठी, इंग्रजी, गणित आणि बुद्धिमत्ता चाचणी.</li>
    <li>प्रत्येक विषयामध्ये २५ प्रश्न असतील.</li>
    <li>प्रत्येक प्रश्न १ गुणाचा असेल.</li>
    <li>परीक्षेची एकूण वेळ ९० मिनिटे आहे.</li>
    <li>चुकीच्या उत्तरासाठी नकारात्मक गुण (Negative Marks) दिले जाणार नाहीत.</li>
  </ul>
</div>

      </div>

    </div> 
  );
}; 

export default ExamEdit;
